var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      ref: "popver-download",
      attrs: { placement: "bottom", trigger: "click" },
      on: { show: _vm.onShowEvent, hide: _vm.onHideEvent },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "nav-downloads-wrapper",
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _c("svg-icon", {
            attrs: {
              "class-name": "nav-file-download",
              "icon-class": "download",
            },
          }),
          _c("span", { staticStyle: { "margin-right": "5px" } }, [
            _vm._v("Downloads"),
          ]),
          _c("i", {
            staticClass: "el-icon-caret-bottom icon-arrow-down",
            staticStyle: { "margin-left": "5px" },
          }),
        ],
        1
      ),
      _vm.list <= 0
        ? _c("div", [_c("div")])
        : _c(
            "div",
            { staticClass: "download-list-container" },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: item.name,
                  staticClass: "nav-download-item",
                  class: {
                    "border-1": index !== _vm.list.length - 1,
                    "padding-top-0": index === 0,
                    "padding-bottom-0": index === _vm.list.length - 1,
                  },
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "nav-download-name text-12-600" },
                      [_vm._v(_vm._s(item.task_name))]
                    ),
                    item.create_time
                      ? _c("div", { staticClass: "nav-download-time" }, [
                          _vm._v(_vm._s(item.create_time)),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "nav-download-status text-12-400" },
                      [
                        _c("span", [_vm._v("Status: ")]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.task_status === _vm.PENDING,
                                expression: "item.task_status === PENDING",
                              },
                              { name: "loading", rawName: "v-loading" },
                            ],
                            staticClass: "color-1d3a41",
                          },
                          [
                            _vm._v(" Downloading"),
                            _c("div", { staticClass: "loading-dots" }, [
                              _c("div", { staticClass: "dot" }),
                              _c("div", { staticClass: "dot" }),
                              _c("div", { staticClass: "dot" }),
                            ]),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.task_status === _vm.SUCCESS,
                                expression: "item.task_status === SUCCESS",
                              },
                            ],
                            staticClass: "color-blue",
                          },
                          [_vm._v("Ready to Download")]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: [_vm.FAIL, _vm.INITFAIL].includes(
                                  item.task_status
                                ),
                                expression:
                                  "[FAIL,INITFAIL].includes(item.task_status)",
                              },
                            ],
                            staticClass: "color-aaa",
                          },
                          [_vm._v("Failed")]
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "nav-download-icon-container" },
                    [
                      item.task_status === _vm.SUCCESS
                        ? _c(
                            "el-button",
                            {
                              staticClass: "filter-btn-add",
                              attrs: { type: "primary", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDownLoad(item)
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "download" },
                              }),
                              _vm._v(
                                " " + _vm._s(_vm.$t("components.download"))
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }